import {Outlet} from 'react-router-dom';
import {cn} from '@/lib/utils';
import {AppBlockUI} from '../../../app/components/AppBlockUI';
import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {useDebounce} from '../../../app/hooks/useDebounce';
import {useDevice} from '../../../app/hooks/useDevice';
import {DemoLimitReachedDialog} from '../../demo/components/DemoLimitReachedDialog';
import {DemoMessage} from '../../demo/components/DemoMessage';
import {useDemo} from '../../demo/hooks/useDemo';
import {useAssistant} from '../hooks/useAssistant';
import {selectUIBlocked} from '../coreSlice';
import {Feedback} from './Feedback';
import {PageAssistant} from './PageAssistant';
import {PageMessages} from './PageMessages';
import {BeforeSessionExpire} from './BeforeSessionExpire';
import {TopBar} from './TopBar';
export interface LayoutProps {
  className?: string;
}
export const Layout = ({className}: LayoutProps) => {
  const blocked = useAppSelector(selectUIBlocked);
  const [debouncedBlocked] = useDebounce(blocked, {
    delay: blocked ? 0 : 100,
  });
  const {isDemo} = useDemo();
  const {isMobile} = useDevice();
  useAssistant(
    {
      detail: `I'm your assistant for this demo, ready to share information and assist you as we explore.`,
      detailDelay: 0,
      detailInterval: 0,
      summary: 'Welcome!',
      summaryInterval: 0,
      summaryDelay: 0,
    },
    isDemo,
  );
  return (
    <div
      className={cn(className, 'h-full flex flex-col', {
        'min-h-screen': isMobile,
      })}
    >
      <BeforeSessionExpire />
      <TopBar />
      <PageMessages />
      <PageAssistant />
      <Feedback className="hidden md:block" />
      <div className="flex-1 min-h-0 overflow-auto fadein">
        <Outlet />
      </div>
      <DemoMessage className={'fadein'} />
      <DemoLimitReachedDialog />
      <AppBlockUI blocked={debouncedBlocked} />
    </div>
  );
};
